import React from 'react';
import styled from '@emotion/styled';
import { css as jsstyle } from '@emotion/react';
// ---- external imports ----


function BackdropSideBlinders() {
	return (<>
		<LeftBlinder />
		<RightBlinder />
	</>);
}

const sideBlinderStyle = () => jsstyle`
	position: absolute;
	top: 0;
	height: 100%;
	background-color: black;
	z-index: 1000;
`;

const LeftBlinder = styled.div`
	${sideBlinderStyle}
	left: 0;
	width: var(--offsetLeft);
`;

const RightBlinder = styled.div`
	${sideBlinderStyle}
	left: calc(var(--offsetLeft) + var(--boxedWidth));
	width: calc(100vw - var(--offsetLeft) - var(--boxedWidth));
`;


export default BackdropSideBlinders;
